/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllKeyCloakUsers } from './keyCloakAction';
   
const initialState = {
    data: {},
    keyCloakUsers:[], 
}
const keyCloakSlice = createSlice({
    name: 'keycloak',
    initialState,
    extraReducers: {

        [getAllKeyCloakUsers.fulfilled]: (state, { payload }) => {
            state.keyCloakUsers =  payload;
        },
      
    }
});

export default keyCloakSlice.reducer